class @App.Ui.CustomSelects
  constructor: ->
    $('.chosen').each ->
      $el = $(@)

      $el.chosen
        ###
        See all chosen options: https://harvesthq.github.io/chosen/options.html
        ###
        allow_single_deselect: $el.data('chosen-allow-single-deselect') ? true
        disable_search: $el.data('chosen-disable-search') ? false
        disable_search_threshold: $el.data('chosen-disable-search-threshold') ? 0
        enable_split_word_search: $el.data('chosen-enable-split-word-search') ? true
        inherit_select_classes: $el.data('chosen-inherit-select-classes') ? false
        max_selected_options: $el.data('chosen-max_selected_options') ? Infinity
        no_results_text: $el.data('chosen-no-results-text') ? 'No results matched'
        placeholder_text_multiple: $el.data('chosen-placeholder-text-multiple') ? "Select Some Options"
        placeholder_text_single: $el.data('chosen-placeholder-text-single') ? "Select an Option"
        search_contains: $el.data('chosen-search-contains') ? false
        single_backstroke_delete: $el.data('chosen-single-backstroke-delete') ? true
        display_disabled_options: $el.data('chosen-display-disabled-options') ? true
        display_selected_options: $el.data('chosen-display-selected-options') ? true
        width: $el.data('chosen-width') ? null
$ ->
  new App.Ui.CustomSelects if $('.chosen').length
